/******************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation.
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *****************************************************************************/

import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { MainContext, useReportedQuery } from 'openvsx-webui';

/** The static content (a markdown document) served at `url`; a failed load is reported to the user. */
export const useDocument = (url: string) => {
  const { service } = useContext(MainContext);
  return useReportedQuery(
    useQuery({
      queryKey: ['document', url],
      queryFn: ({ signal }) => service.getStaticContent(signal, url)
    }),
    { action: 'load the page' }
  );
};
